import React from 'react';
import classNames from 'classnames';
import {SectionSplitProps} from '../../utils/SectionProps';
import SectionHeader from './partials/SectionHeader';
import Image from '../elements/Image';
import {FormattedMessage} from "react-intl";

const propTypes = {
    ...SectionSplitProps.types
}

const defaultProps = {
    ...SectionSplitProps.defaults
}

const FeaturesSplit = ({
                           className,
                           topOuterDivider,
                           bottomOuterDivider,
                           topDivider,
                           bottomDivider,
                           hasBgColor,
                           invertColor,
                           invertMobile,
                           invertDesktop,
                           alignTop,
                           imageFill,
                           ...props
                       }) => {

    const outerClasses = classNames(
        'features-split section',
        topOuterDivider && 'has-top-divider',
        bottomOuterDivider && 'has-bottom-divider',
        hasBgColor && 'has-bg-color',
        invertColor && 'invert-color',
        className
    );

    const innerClasses = classNames(
        'features-split-inner section-inner',
        topDivider && 'has-top-divider',
        bottomDivider && 'has-bottom-divider'
    );

    const splitClasses = classNames(
        'split-wrap',
        invertMobile && 'invert-mobile',
        invertDesktop && 'invert-desktop',
        alignTop && 'align-top'
    );

    const sectionHeader = {
        title: 'Una estrategia que funciona',
        paragraph: 'Nuestros expertos conseguirán que llegue a sus objetivos con un trabajo de calidad.',
        section: 'featureSplit'
    };

    return (
        <section
            {...props}
            className={outerClasses}
        >
            <div className="container">
                <div className={innerClasses}>
                    <SectionHeader data={sectionHeader} className="center-content"/>
                    <div className={splitClasses}>
                        <div className="split-item">
                            <div className="split-item-content center-content-mobile reveal-from-left"
                                 data-reveal-container=".split-item">
                                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                                    <FormattedMessage
                                        id="app.hero.feature_split_process"
                                        defaultMessage="NUESTRO PROCESO"
                                    />
                                </div>
                                <h3 className="mt-0 mb-12">
                                    <FormattedMessage
                                        id="app.hero.feature_split_one_title"
                                        defaultMessage="Análisis"
                                    />
                                </h3>
                                <p className="m-0">
                                    <FormattedMessage
                                        id="app.hero.feature_split_one_description"
                                        defaultMessage="Te escuchamos, investigamos y analizamos tus necesidades y lo que es más adecuado para potenciar tu producto."
                                    />
                                </p>
                            </div>
                            <div className={
                                classNames(
                                    'split-item-image center-content-mobile reveal-from-bottom',
                                    imageFill && 'split-item-image-fill'
                                )}
                                 data-reveal-container=".split-item">
                                <Image
                                    src={require('./../../assets/images/features-split-image-01.png')}
                                    alt="Features split 01"
                                    width={528}
                                    height={396}/>
                            </div>
                        </div>
                        <div className="split-item">
                            <div className="split-item-content center-content-mobile reveal-from-right"
                                 data-reveal-container=".split-item">
                                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                                    <FormattedMessage
                                        id="app.hero.feature_split_process"
                                        defaultMessage="NUESTRO PROCESO"
                                    />
                                </div>
                                <h3 className="mt-0 mb-12">
                                    <FormattedMessage
                                        id="app.hero.feature_split_two_title"
                                        defaultMessage="Diseño y desarrollo"
                                    />
                                </h3>
                                <p className="m-0">
                                    <FormattedMessage
                                        id="app.hero.feature_split_two_description"
                                        defaultMessage="Aplicamos todo nuestro conocimiento a ejecutar el plan de acción diseñado para lograr tu éxito digital."
                                    />
                                </p>
                            </div>
                            <div className={
                                classNames(
                                    'split-item-image center-content-mobile reveal-from-bottom',
                                    imageFill && 'split-item-image-fill'
                                )}
                                 data-reveal-container=".split-item">
                                <Image
                                    src={require('./../../assets/images/features-split-image-02.png')}
                                    alt="Features split 02"
                                    width={528}
                                    height={396}/>
                            </div>
                        </div>
                        <div className="split-item">
                            <div className="split-item-content center-content-mobile reveal-from-left"
                                 data-reveal-container=".split-item">
                                <div className="text-xxs text-color-primary fw-600 tt-u mb-8">
                                    <FormattedMessage
                                        id="app.hero.feature_split_process"
                                        defaultMessage="NUESTRO PROCESO"
                                    />
                                </div>
                                <h3 className="mt-0 mb-12">
                                    <FormattedMessage
                                        id="app.hero.feature_split_three_title"
                                        defaultMessage="Analítica"
                                    />
                                </h3>
                                <p className="m-0">
                                    <FormattedMessage
                                        id="app.hero.feature_split_three_description"
                                        defaultMessage="Analizaremos las métricas y la evolución de tu marca y/o producto en las redes para mantener o mejorar la estrategia seguida."
                                    />
                                </p>
                            </div>
                            <div className={
                                classNames(
                                    'split-item-image center-content-mobile reveal-from-bottom',
                                    imageFill && 'split-item-image-fill'
                                )}
                                 data-reveal-container=".split-item">
                                <Image
                                    src={require('./../../assets/images/features-split-image-03.png')}
                                    alt="Features split 03"
                                    width={528}
                                    height={396}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

FeaturesSplit.propTypes = propTypes;
FeaturesSplit.defaultProps = defaultProps;

export default FeaturesSplit;